import React from "react";
import tw from "twin.macro";
import styled from "styled-components";

const SwitchWrapper = tw.label`flex items-center cursor-pointer w-full justify-between mt-5`;

const SwitchInput = tw.input`hidden`;

const SwitchTrack = styled.div`
  ${tw`w-12 h-6 bg-gray-400 rounded-full relative transition-colors duration-300`}
`;

const SwitchThumb = styled.div`
  ${tw`absolute w-5 h-5 bg-white rounded-full transition-transform duration-300`}
  top: 2px;
  left: 2px;
`;

const SwitchLabel = tw.span`ml-3 font-medium flex-1`;

export default function ToggleSwitch({
  checked = false,
  onChange,
  label = "",
  disabled = false,
  className = "",
}) {
  return (
    <SwitchWrapper className={className}>
      <SwitchInput
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />

      {label && <SwitchLabel>{label}</SwitchLabel>}

      <SwitchTrack
        style={{
          backgroundColor: checked ? "#22c55e" : "#9ca3af",
          opacity: disabled ? 0.6 : 1,
        }}
      >
        <SwitchThumb
          style={{
            transform: checked ? "translateX(24px)" : "translateX(0)",
          }}
        />
      </SwitchTrack>

    </SwitchWrapper>
  );
}
